import React, { useState, useEffect } from 'react';

import { Col, Layout, Row } from 'antd';
import classnames from 'classnames';
import routePaths from 'config/routes';
import { NextPage } from 'next';
import { useRouter } from 'next/router';
import { connect } from 'react-redux';
// import LanguageSelect from 'src/components/LanguageSelect';
import FooterCols from 'src/components/layout/FooterCols';
import { getFooter } from 'src/components/menu/Menu.utils';
import { IRootReducers } from 'src/reducers';
import { IMenu } from 'src/shared/models';
import { isConPlatform } from 'utils';

const { LOGIN, SIGNUP } = routePaths.PAGES;

type Props = ReturnType<typeof mapStateToProps>;

const BasicFooterCopyright: NextPage<Props, {}> = ({
  authenticated,
  publicMenu,
  privateMenu,
}) => {
  const { pathname } = useRouter();
  const [menu, setMenu] = useState<IMenu[]>(
    getFooter(authenticated, publicMenu, privateMenu, true)
  );

  useEffect(() => {
    setMenu(getFooter(authenticated, publicMenu, privateMenu, true));
  }, [authenticated, publicMenu, privateMenu]);

  const isAuthPage = pathname.includes(LOGIN) || pathname.includes(SIGNUP);
  const componentCustomMenu = FooterCols(menu, true);
  const hasMenusAtBottom =
    componentCustomMenu?.props?.children?.length > 0 ?? false;

  const renderTitle = () => {
    return 'Copyright © ISDIN All rights reserved.';
  };

  return (
    <Layout.Footer className={`basicFooter`}>
      <Row
        justify="space-between"
        align="middle"
        className={classnames({
          'basicFooter__copyright extra-small-body':
            !isConPlatform || hasMenusAtBottom,
          'basicFooter__copyright--auth-page': isAuthPage,
          'con-footer-app-menu__copyright': isConPlatform && !hasMenusAtBottom,
        })}
      >
        <Row
          className={classnames({
            'container basicFooter__copyright-container':
              !isConPlatform || hasMenusAtBottom,
            'con-footer-app-menu__copyright__container':
              isConPlatform && !hasMenusAtBottom,
          })}
        >
          {!isConPlatform || hasMenusAtBottom ? (
            <Row align="middle" className="text-center">
              {renderTitle()}
            </Row>
          ) : (
            <span>{renderTitle()}</span>
          )}
          {hasMenusAtBottom && (
            <Row className="container-footer-link" align="middle">
              {componentCustomMenu}
              <Col xs={6} lg={4} style={{ padding: 0, display: 'none' }}>
                <Row justify={'center'}>{/* <LanguageSelect /> */}</Row>
              </Col>
            </Row>
          )}
        </Row>
      </Row>
    </Layout.Footer>
  );
};

const mapStateToProps = (state: IRootReducers) => {
  return {
    authenticated:
      state.auth.accessToken !== null && state.auth.accessToken !== '',
    publicMenu: state.app.publicMenu,
    privateMenu: state.app.userMenu,
  };
};

export default connect(mapStateToProps, null)(BasicFooterCopyright);
